import { useState } from "react";

import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Icon, IconButton, LinkButton } from "@/DesignSystem";

import styles from "./FilterSearchComponent.module.scss";

import MagnifyingGlass from "@/DesignSystem/Atoms/Icons/Types/MagnifyingGlass/magnifying-glass-regular.svg";
import NewItem from "@/DesignSystem/Atoms/Icons/Types/NotePencil/note-pencil-regular.svg";

interface FilterSearchComponentProps {
    searchText: string;
    dateFrom: Date;
    dateTo: Date;
    onSearchTextChange: (text: string) => void;
    onDateFromChange: (fromDate: Date) => void;
    onDateToChange: (toDate: Date) => void;
    onCreateNewItem: () => void;
}

export function FilterSearchComponent(props: Readonly<FilterSearchComponentProps>): JSX.Element {
    const [isCriteriaExpanded, setIsCriteriaExpanded] = useState<boolean>(false);

    const { getText } = useTranslation();
    const critariaText = isCriteriaExpanded ? "[-] " : "[+] ";

    return (
        <div className={styles.filterSearchContainer}>
            <div className={styles.searchContainer}>
                <div className={`${styles.textField} form-control`}>
                    <Icon size="sm" colorVariant="neutral">
                        <MagnifyingGlass />
                    </Icon>
                    <TextboxControl
                        debounceMs={400}
                        value={props.searchText}
                        onChange={text => props.onSearchTextChange(text)}
                        placeholder={getText("SearchLabel")}
                        dataCy="filter-search-text-box"
                    />
                </div>
                <IconButton onClick={() => props.onCreateNewItem()} dataCy="filter-search-new-item-button">
                    <Icon>
                        <NewItem />
                    </Icon>
                </IconButton>
            </div>
            {isCriteriaExpanded && (
                <MultiDateSelector
                    id="FilterSearchDates"
                    from={props.dateFrom}
                    to={props.dateTo}
                    fullWidth
                    fromSetTodayLabel={getText("TodayLabel")}
                    toSetTodayLabel={getText("TodayLabel")}
                    fromChange={date => props.onDateFromChange(date)}
                    toChange={date => props.onDateToChange(date)}
                    cssClass={styles.dateSelector}
                    dataCy="filter-setting-date-selector"
                />
            )}
            <div className={styles.criteria}>
                <LinkButton
                    label={critariaText + getText("CriteriaLabel")}
                    underline={false}
                    onClick={() => setIsCriteriaExpanded(!isCriteriaExpanded)}
                    dataCy="filter-setting-criteria-link-botton"
                />
            </div>
        </div>
    );
}
